module.exports = __webpack_public_path__ + "img/check.6bd2f279.png";